import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarMenu,
  SidebarGroup,
} from '@predoc/cow';
import { Settings } from 'lucide-react';
import { NavUser } from '@/feature/layout/NavUser';
import { lowerNavItems, upperNavItems } from '@/feature/layout/constants';
import { Permission, useHasPermission } from '@/utils/roles';
import { useGetOrganizationInfo } from '@/feature/profiles/hooks/organizationAPI';

import { DownloadsNavItem } from '@/feature/downloads/DownloadsSheet';
import { AppSidebarHeader } from './AppSidebarHeader';
import { SidebarNavItem } from './SidebarNavitem';

const OrganizationSettingsNavItem = () => {
  const { hasPermission } = useHasPermission(
    Permission.VIEW_ORGANIZATION_SETTINGS,
  );
  const { data: organizationInfo } = useGetOrganizationInfo();

  if (!hasPermission || !organizationInfo?.enableDataDeletionRequests) {
    return null;
  }

  return (
    <SidebarNavItem
      title="Organization Settings"
      url="/organization-settings"
      icon={Settings}
    />
  );
};

export const AppSidebar = () => {
  return (
    <Sidebar collapsible="icon">
      <AppSidebarHeader />
      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            {upperNavItems.map((item) => (
              <SidebarNavItem key={item.title} {...item} />
            ))}
            <DownloadsNavItem />
          </SidebarMenu>
        </SidebarGroup>
        <SidebarGroup className="mt-auto">
          <SidebarMenu>
            {lowerNavItems.map((item) => (
              <SidebarNavItem key={item.title} {...item} />
            ))}
            <OrganizationSettingsNavItem />
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>{<NavUser />}</SidebarFooter>
    </Sidebar>
  );
};
